import AddUSSDString from "./AddUSSDString";
import AddShortCode from "./AddShortCode";
import AllocateShortCode from "./AllocateShortCode";

//Indexed by Licensed Service ID
export default {
    1: { //USSD
        add: AddUSSDString,
        onStateChange: {
            "allocated": () => null,
            "available": () => null,
            "reserved": () => null,
            "in-house": () => null
        }
    },
    2: { //Short Code
        add: AddShortCode,
        view: AllocateShortCode,
        onStateChange: {
            "allocated": () => null,
            "available": () => null,
            "reserved": () => null,
            "in-house": () => null
        }
    }
}